<template>
  <div>
    {{ $store.state.users.current_user.id }}
  </div>
</template>
